/**
 * Moduł do zarządzania dialogiem potwierdzenia
 *
 * @export
 * @class ConfirmModule
 */
export class ConfirmModule {
  /**
   * Domyślny stan modułu
   *
   * @private
   * @memberof ConfirmModule
   */
  private defaultState = {
    confirm: undefined
  };

  /**
   * Stan modułu
   *
   * @memberof ConfirmModule
   */
  public state = {
    ...this.defaultState
  };

  public mutations = {
    /**
     * Ustawia wyświetlanie dialogu potwierdzenia
     *
     * @param {*} localState
     * @param {*} payload
     */
    showConfirm(localState: any, payload: any) {
      if (payload.closeButton === undefined) {
        payload.closeButton = 'Nie';
      }
      if (payload.submitButton === undefined) {
        payload.submitButton = 'Tak';
      }
      localState.confirm = payload;
    }
  };

  public actions = {
    /**
     * Ustawia wyświetlanie dialogu potwierdzenia
     *
     * @param {*} context
     * @param {*} value
     */
    setConfirm(context: any, value: any) {
      context.commit('showConfirm', value);
    }
  };

  public getters = {};
}

export default new ConfirmModule();
